import {
  LandingBullet,
  LandingFaq,
  LandingMedia,
  LandingProduct,
  LandingStep,
  LandingTestimonial,
  LandingTrustStat,
  LandingValueProp,
} from '../models/landing.models';

/** URL externa de reserva de asesoría (HubSpot meetings), usada en header, hero y CTA final. */
export const ADVISORY_BOOKING_URL = 'https://inversioninmobiliaria.inviertis.es/meetings/rperez10/asesoria';

/**
 * Rutas relativas dentro de la carpeta de assets públicos del proyecto anfitrión.
 * Ver README.md -> "Assets" para el paso de copia requerido tras integrar esta feature.
 */
export const HERO_IMAGES: string[] = [
  'assets/landing-inversores/hero-living.jpg',
  'assets/landing-inversores/hero-kitchen.jpg',
  'assets/landing-inversores/hero-bedroom.jpg',
  'assets/landing-inversores/hero-corner.jpg',
];

export const LOGO_IMAGE = 'assets/landing-inversores/inviertis-logo.jpg';

export const HERO_BULLETS: LandingBullet[] = [
  { strong: 'Pisos ya alquilados', rest: 'con inquilinos solventes y contrato en vigor' },
  { strong: 'Rentabilidad inmediata', rest: 'del 6% al 11% desde el día 1' },
  { strong: 'Oportunidades en exclusiva', rest: 'que no encontrarás en ningún otro sitio' },
  { strong: 'Acompañamiento integral', rest: 'análisis, oferta, firma, alquiler y seguros' },
];

export const TRUST_STATS: LandingTrustStat[] = [
  { icon: 'users', k: '+20.000', v: 'Inversores que confían' },
  { icon: 'trending-up', k: '6% – 11%', v: 'Rentabilidad anual' },
  { icon: 'home', k: '100%', v: 'Pisos ya alquilados' },
  { icon: 'award', k: 'Exclusiva', v: 'Oportunidades únicas' },
];

// TODO: VALIDAR CON NEGOCIO — citas y cifras de prensa reproducidas literalmente del original.
export const MEDIA_MENTIONS: LandingMedia[] = [
  {
    name: 'Forbes',
    quote: 'Inviertis alcanzó en 2024 un récord de 76 millones de euros en activos bajo gestión.',
    url: 'https://forbes.es/economia/708578/inviertis-alcanzo-en-2024-un-record-de-76-millones-de-euros-en-activos-inmobiliarios-bajo-gestion/',
    themeClass: 'forbes',
  },
  {
    name: 'La Vanguardia',
    quote: 'Una plataforma para comprar y vender pisos ya alquilados con inquilinos.',
    url: 'https://www.lavanguardia.com/economia/emprendedores/20190524/462423763698/inviertis-plataforma-comprar-vender-pisos-inquilinos.html',
    themeClass: 'vanguardia',
  },
  {
    name: 'Invertia',
    quote: 'La compra de vivienda para alquilar se dispara: cierran el doble de operaciones.',
    url: 'https://www.elespanol.com/invertia/observatorios/vivienda/20230210/compra-vivienda-alquilar-dispara-cierran-doble-operaciones/739926159_0.html',
    themeClass: 'invertia',
  },
  {
    name: 'BrainsRE News',
    quote: 'Anticipa se alía con Inviertis para agilizar la venta de activos.',
    url: 'https://brainsre.news/anticipa-se-alia-con-inviertis-para-agilizar-la-venta-de-activos/',
    themeClass: 'brains',
  },
  {
    name: 'Expansión',
    quote: 'Inviertis impulsa su plataforma de inversión inmobiliaria en toda España.',
    url: 'https://www.expansion.com/catalunya/2024/09/28/66f72006468aebc30e8b457d.html',
    themeClass: 'vanguardia',
  },
  {
    name: 'El Confidencial',
    quote: 'Nuevas fórmulas de inversión inmobiliaria con rentabilidad verificada.',
    url: 'https://www.elconfidencial.com',
    themeClass: 'confidencial',
  },
];

export const PROCESS_STEPS: LandingStep[] = [
  {
    n: '1',
    title: 'Filtra por tu perfil',
    desc: 'Elige rentabilidad mínima, precio, ciudad y tipo de inmueble. Solo ves lo que encaja contigo.',
  },
  {
    n: '2',
    title: 'Compara con análisis real',
    desc: 'Ficha financiera completa con yield bruto, yield neto, flujo de caja e informe del arquitecto.',
  },
  {
    n: '3',
    title: 'Lanza tu oferta directa',
    desc: 'Envía tu oferta al vendedor sin intermediarios. Nosotros te guiamos en cada paso.',
  },
  {
    n: '4',
    title: 'Firma online y cobra desde el día 1',
    desc: 'Reserva y arras 100% online. El piso ya está alquilado: empiezas a cobrar renta inmediatamente.',
  },
];

// TODO: VALIDAR CON NEGOCIO — ticket "70.000€ – 450.000€" del producto vs. "mínimo 100.000€ / 60.000€ con financiación" citado en hero y FAQ.
export const INVESTMENT_PRODUCTS: LandingProduct[] = [
  {
    img: 'assets/landing-inversores/product-pisos.jpg',
    title: 'Pisos alquilados y analizados',
    badge: 'Solvencia verificada',
    yieldRange: '6% – 11%',
    ticket: '70.000€ – 450.000€',
    liquidity: '40%',
    time: 'Inmediato',
    desc: 'Pisos en toda España analizados uno a uno, con inquilino solvente verificado y contrato en vigor.',
  },
  {
    img: 'assets/landing-inversores/product-obra.jpg',
    title: 'Edificios para reformar y vender',
    badge: 'Plusvalía',
    yieldRange: '6%',
    ticket: 'Desde 1.000.000€',
    liquidity: '40%',
    time: '8 meses',
    desc: 'Compra de edificios, reforma y venta gestionada de principio a fin.',
  },
  {
    img: 'assets/landing-inversores/product-tickets.jpg',
    title: 'Inversiones colaborativas',
    badge: 'En grupo',
    yieldRange: '10% – 20% TIR',
    ticket: 'Desde 25.000€',
    liquidity: '100%',
    time: '8 – 15 meses',
    desc: 'Compra, reforma y venta junto a otros inversores. Diversifica tu capital.',
  },
];

export const VALUE_PROPS: LandingValueProp[] = [
  {
    icon: 'clipboard-check',
    title: 'Verificación técnica real',
    desc: 'Un arquitecto visita y certifica cada inmueble antes de publicarlo. Estado, instalaciones y pagos al corriente.',
  },
  {
    icon: 'calculator',
    title: 'Análisis financiero por propiedad',
    desc: 'Yield bruto, yield neto, flujo de caja mensual y crecimiento esperado. Decides con datos, no con intuición.',
  },
  {
    icon: 'zap',
    title: 'Cierre en menos de 40 días',
    desc: 'Reserva y firma de arras 100% online. Sin esperas, sin desplazamientos.',
  },
  {
    icon: 'building',
    title: 'Gestión post-compra',
    desc: 'Seguro de impago, gestora de alquiler y asesoría hipotecaria. Un solo interlocutor para todo.',
  },
];

export const WHY_INVIERTIS: LandingValueProp[] = [
  {
    icon: 'database',
    title: 'Decisiones con datos',
    desc: 'Analizamos cada propiedad con datos reales de mercado, contrato e inquilino antes de publicarla.',
  },
  {
    icon: 'shield-check',
    title: 'Acompañamiento integral',
    desc: 'Análisis, oferta, firma, alquiler y seguros. Un equipo dedicado durante todo el proceso.',
  },
  {
    icon: 'clock',
    title: 'Rentabilidad inmediata',
    desc: 'Como los pisos ya están alquilados, empiezas a cobrar la renta desde el día de la firma.',
  },
];

// TODO: VALIDAR CON NEGOCIO — testimonios reproducidos literalmente del original.
export const TESTIMONIALS: LandingTestimonial[] = [
  {
    name: 'Carlos M.',
    role: 'Opinión en Google',
    quote:
      'Compré mi primer piso de inversión con Inviertis y ya estaba alquilado. Cobro la renta desde el primer mes. El equipo es muy profesional.',
  },
  {
    name: 'Ana L.',
    role: 'Opinión en Google',
    quote:
      'Me presentaron oportunidades que no había visto en ningún portal. La negociación y la firma fueron muy ágiles. Repetiré sin duda.',
  },
  {
    name: 'David R.',
    role: 'Opinión en Google',
    quote:
      'Transparencia absoluta con los números. Me explicaron la rentabilidad real, el contrato del inquilino y todos los gastos. Recomendable 100%.',
  },
];

export const GOOGLE_REVIEWS_URL = 'https://www.google.com/search?q=Inviertis+opiniones';

// TODO: VALIDAR CON NEGOCIO — inversión mínima 100.000€ (60.000€ con financiación) citada en hero y FAQ.
export const FAQS: LandingFaq[] = [
  {
    q: '¿Los pisos ya están alquilados cuando los compro?',
    a: 'Sí. Todos los pisos que publicamos están alquilados, con inquilino verificado y contrato en vigor. Empiezas a recibir la renta desde el día de la firma.',
  },
  {
    q: '¿Reformáis las viviendas?',
    a: 'No. Nuestro modelo es distinto: analizamos pisos que ya están alquilados a inquilinos solventes y solo publicamos los que son una buena oportunidad de inversión.',
  },
  {
    q: '¿Cuánto necesito para empezar a invertir?',
    a: 'La inversión mínima es de 100.000€. Si dispones de financiación, puedes empezar desde 60.000€ de capital propio.',
  },
  {
    q: '¿Puedo encontrar vuestros pisos en otros portales?',
    a: 'No. Trabajamos en exclusiva: nuestras oportunidades no las vas a encontrar en ningún otro portal ni inmobiliaria.',
  },
  {
    q: '¿De qué os encargáis exactamente?',
    a: 'De todo: análisis de la propiedad, envío y negociación de la oferta al propietario o fondo, gestiones para la firma, acompañamiento en notaría y gestión del alquiler y los seguros.',
  },
  {
    q: '¿Cuáles son vuestros honorarios?',
    a: 'Cobramos una comisión transparente que se acuerda contigo antes de iniciar el proceso. Sin sorpresas ni costes ocultos.',
  },
];
